/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  contain: content;
  display: block;
  height: calc(22rem/14);
  overflow: hidden;
  position: relative;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
}
:host .scroll-container {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: -calc(-25rem/14);
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
:host .fadeout-hidden {
  display: none;
}
:host .fadeout-right, :host .fadeout-left {
  width: calc(20rem/14);
  height: calc(20rem/14);
  position: absolute;
  z-index: 1;
  top: 0;
  pointer-events: none;
}
:host .fadeout-right {
  background: -webkit-gradient(linear, right top, left top, from(#fbfbfb), to(rgba(251, 251, 251, 0)));
  background: linear-gradient(to left, #fbfbfb 0%, rgba(251, 251, 251, 0) 100%);
  right: 0;
}
:host .fadeout-left {
  background: -webkit-gradient(linear, left top, right top, from(#fbfbfb), to(rgba(251, 251, 251, 0)));
  background: linear-gradient(to right, #fbfbfb 0%, rgba(251, 251, 251, 0) 100%);
  left: 0;
}`;
export { style };
//# sourceMappingURL=Breadcrumb.style.js.map